/**
 * Auth Module
 */
import Cookie from 'js-cookie'
import config from '@/config'
import axios from 'axios'
//import firebase from 'firebase/app'
//import 'firebase/auth'
import Vue from 'vue'
import Nprogress from 'nprogress'
import router from '../../../router'
// import {
//     facebookAuthProvider,
//     googleAuthProvider,
//     twitterAuthProvider,
//     githubAuthProvider
// } from '../../../firebase'
let storage = JSON.parse(window.localStorage.getItem('authUser')) || {}
const state = {
    isUserSigninWithAuth0: Boolean(localStorage.getItem('isUserSigninWithAuth0')),
    storage: JSON.parse(window.localStorage.getItem('authUser')) || {},
    user: {},
    name: null,
    token: null,
    avatar: null,
    role: [],
    phone: null,
    phone1: null,
    email: null,
    roles: config.userRoles
}

// getters
const getters = {
    getUser: state => {
        return state.user
    },
    isUserSigninWithAuth0: state => {
        return state.isUserSigninWithAuth0
    },
    user: state => {
        if (state && state.token) { return state } else { return {} }
    },
    hasRole: state => (role) => {
        let authorized = false;
        for (let r of state.role) {
            authorized = state.roles.indexOf(r) >= state.roles.indexOf(role) || authorized;
        }
        return authorized;
    },
    token() {
        if (state.token) { return 'Bearer ' + state.token }
    }
}

// actions
const actions = {
    async signup({ dispatch, commit }, payload) {
        const response = await axios.post('/api/users', payload)
        let data = response.data
        if (data) {
            data.user.token = data.token
            commit('setToken', data.token)
            commit('setUser', data.user)
            return data
        }
    },
    async login({ dispatch, commit }, payload) {
        try {
            let res = await axios.post('/auth/local', payload)
            if (res) {
                let data = res.data
                data.user.token = data.token
                commit('setUser', data.user)
                commit('setToken', data.token)
                commit('clearError', null, { root: true })
                commit('loginUserSuccess', data.user)
                    // router.push('/')
                return data
            } else {
                commit('loginUserFailure', { message: 'Incorrect Username and password' })
            }
        } catch (err) {
            console.log(err);
            commit('loginUserFailure', err)
        }
    },
    async forgotPassword({ dispatch, commit, state }, payload) {
        const response = await axios.post('/api/users/forgot', payload)
        const data = response.data
        if (data) { commit('setMessage', data.message, { root: true }) }
        return data
    },
    async changePassword({ dispatch, commit, state, rootState }, payload) {
        // if (demo) {
        //   commit('setMessage', 'Demo mode: Unable to change password', { root: true })
        //   return
        // }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.user.token
        const response = await axios.put('/api/users/password', payload)
        const data = response.data
        router.push('/admin')
    },
    async resetPassword({ dispatch, commit, state }, payload) {
        const response = await axios.post('/api/users/reset/' + payload.id, payload)
        const data = response.data
        if (data) {
            commit('setMessage', data.message, { root: true })
            router.push('/')
        }
        return data
    },
    async updateProfile({ dispatch, commit, state, rootState }, payload) {
        // if (demo) {
        //   commit('setMessage', 'Demo mode: Unable to update profile info', { root: true })
        //   return
        // }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.user.token
        const response = await axios.put('/api/users/' + payload._id, { name: payload.name, email: payload.email, phone1: payload.phone1, avatar: payload.avatar }, state.token)
        let data = response.data
        if (data) {
            data.token = state.token
            commit('setUser', data)
            commit('setMessage', 'Successfully updated', { root: true })
            return data
        }
    },
    logout({ dispatch, commit }) {
        // commit('clearError', null, { root: true })
        commit('setUser', {})
        commit('removeToken')
        router.push('/')
    },
    // // signinUserInFirebase(context, payload) {
    // //     const { user } = payload
    // //     context.commit('loginUser')
    // //     firebase.auth().signInWithEmailAndPassword(user.email, user.password)
    // //         .then(user => {
    // //             Nprogress.done()
    // //             setTimeout(() => {
    // //                 context.commit('loginUserSuccess', user)
    // //             }, 500)
    // //         })
    // //         .catch(error => {
    // //             context.commit('loginUserFailure', error)
    // //         })
    // // },
    // logoutUserFromFirebase(context) {
    //     Nprogress.start()
    //     firebase.auth().signOut()
    //         .then(() => {
    //             Nprogress.done()
    //             setTimeout(() => {
    //                 context.commit('logoutUser')
    //             }, 500)
    //         })
    //         .catch(error => {
    //             context.commit('loginUserFailure', error)
    //         })
    // },
    // signinUserWithFacebook(context) {
    //     context.commit('loginUser')
    //     firebase.auth().signInWithPopup(facebookAuthProvider).then((result) => {
    //         Nprogress.done()
    //         setTimeout(() => {
    //             context.commit('loginUserSuccess', result.user)
    //         }, 500)
    //     }).catch(error => {
    //         context.commit('loginUserFailure', error)
    //     })
    // },
    // signinUserWithGoogle(context) {
    //     context.commit('loginUser')
    //     firebase.auth().signInWithPopup(googleAuthProvider).then((result) => {
    //         Nprogress.done()
    //         setTimeout(() => {
    //             context.commit('loginUserSuccess', result.user)
    //         }, 500)
    //     }).catch(error => {
    //         context.commit('loginUserFailure', error)
    //     })
    // },
    // signinUserWithTwitter(context) {
    //     context.commit('loginUser')
    //     firebase.auth().signInWithPopup(twitterAuthProvider).then((result) => {
    //         Nprogress.done()
    //         setTimeout(() => {
    //             context.commit('loginUserSuccess', result.user)
    //         }, 500)
    //     }).catch(error => {
    //         context.commit('loginUserFailure', error)
    //     })
    // },
    // signinUserWithGithub(context) {
    //     context.commit('loginUser')
    //     firebase.auth().signInWithPopup(githubAuthProvider).then((result) => {
    //         Nprogress.done()
    //         setTimeout(() => {
    //             context.commit('loginUserSuccess', result.user)
    //         }, 500)
    //     }).catch(error => {
    //         context.commit('loginUserFailure', error)
    //     })
    // },
    // signupUserInFirebase(context, payload) {
    //     let { userDetail } = payload
    //     context.commit('signUpUser')
    //     firebase.auth().createUserWithEmailAndPassword(userDetail.email, userDetail.password)
    //         .then(() => {
    //             Nprogress.done()
    //             setTimeout(() => {
    //                 context.commit('signUpUserSuccess', userDetail)
    //             }, 500)
    //         })
    //         .catch(error => {
    //             context.commit('signUpUserFailure', error)
    //         })
    // },
    signInUserWithAuth0(context, payload) {
        context.commit('signInUserWithAuth0Success', payload)
    },
    signOutUserFromAuth0(context) {
        context.commit('signOutUserFromAuth0Success')
    },
    initAuth({ commit }) {
        let token, name, avatar, role, phone, phone1, email, jwtToken, jwtUser, jwtAvatar, jwtRole, jwtPhone, jwtPhone1, jwtEmail
        token = localStorage.getItem('token')
        name = localStorage.getItem('name')
        avatar = localStorage.getItem('avatar')
        role = localStorage.getItem('role')
        phone = localStorage.getItem('phone')
        phone1 = localStorage.getItem('phone1')
        email = localStorage.getItem('email')
        role = role ? role.split(',') : ''
        commit('populateUser', { name, avatar, role, phone, phone1, email })
        commit('populateToken', token)
    }
}

// mutations
const mutations = {
    populateUser(state, user) {
        if (!user) return
        state.name = user.name
        state.avatar = user.avatar
        state.role = user.role
        state.phone = user.phone
        state.phone1 = user.phone1
        state.email = user.email
            // state.token = user.token
    },
    populateToken(state, token) {
        if (token) { state.token = token }
    },
    setUser(state, user) { // only from the click of login,signup,profile
        if (!user || !user.role) return

        state.name = user.name
        state.avatar = user.avatar
        state.role = user.role
        state.phone = user.phone
        state.phone1 = user.phone1
        state.email = user.email

        localStorage.setItem('name', user.name)
        localStorage.setItem('avatar', user.avatar)
        localStorage.setItem('role', user.role)
        localStorage.setItem('phone', user.phone)
        localStorage.setItem('phone1', user.phone1)
        localStorage.setItem('email', user.email)

        Cookie.set('name', user.name)
        Cookie.set('avatar', user.avatar)
        Cookie.set('role', user.role)
        Cookie.set('phone', user.phone)
        Cookie.set('phone1', user.phone1)
        Cookie.set('email', user.email)
    },
    setToken(state, token) {
        state.token = token
        localStorage.setItem('token', token)
        Cookie.set('token', token)
    },
    logout(state) {
        this.commit('auth/setUser', {})
        this.commit('auth/setToken', undefined)
        this.$router.push('/')
    },
    // loginUser (state) {
    //   Nprogress.start()
    // },
    removeToken(state, payload) {
        state.token = null
        localStorage.setItem('token', null)
        Cookie.remove('token')
    },
    loginUserSuccess(state, user) {
        state.isUserSigninWithAuth0 = false
            //router.push('/admin/dashboard')
        Vue.notify({
            group: 'loggedIn',
            type: 'success',
            text: 'User Logged In Success!'
        });
        window.location = '/admin/dashboard';
    },
    loginUserFailure(state, error) {
        Nprogress.done()
        Vue.notify({
            group: 'loggedIn',
            type: 'error',
            text: error.message
        });
    }
    // logoutUser (state) {
    //   state.user = null
    //   localStorage.removeItem('userId')
    //   router.push('/session/login')
    // },
    // signUpUser (state) {
    //   Nprogress.start()
    // },
    // signUpUserSuccess (state, user) {
    //   state.user = localStorage.setItem('userId', user)
    //   router.push('/default/dashboard/ecommerce')
    //   VueNotifications.success({ message: 'Account Created!' })
    // },
    // signUpUserFailure (state, error) {
    //   Nprogress.done()
    //   VueNotifications.error({ message: error.message })
    // },
    // signInUserWithAuth0Success (state, user) {
    //   state.user = localStorage.setItem('userId', user)
    //   state.isUserSigninWithAuth0 = true
    // },
    // signOutUserFromAuth0Success (state) {
    //   state.user = null
    //   localStorage.removeItem('userId')
    // }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}